import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxToolbar = _resolveComponent("DxToolbar")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.dataSource,
      "show-borders": true,
      "allow-column-resizing": true,
      "column-auto-width": true,
      "row-alternation-enabled": true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxEditing, {
          "allow-adding": true,
          "allow-updating": true,
          "allow-deleting": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              "show-title": true,
              title: "Tip document HR",
              width: 460,
              height: 440
            }),
            _createVNode(_component_DxForm, null, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, {
                  "data-field": "Cod",
                  "is-required": true
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Denumire",
                  "is-required": true
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "Descriere",
                  "editor-type": "dxTextArea",
                  "editor-options": { height: 80 }
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "NecesitaFisier",
                  "editor-type": "dxCheckBox"
                }),
                _createVNode(_component_DxItem, {
                  "data-field": "IsActiv",
                  "editor-type": "dxCheckBox"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cod",
          caption: "Cod",
          width: 120
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Denumire",
          caption: "Denumire"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Descriere",
          caption: "Descriere"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "NecesitaFisier",
          caption: "Necesită fișier",
          "data-type": "boolean",
          width: 130
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "IsActiv",
          caption: "Activ",
          "data-type": "boolean",
          width: 80
        }),
        _createVNode(_component_DxToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxItem, {
              location: "before",
              name: "addRowButton"
            }),
            _createVNode(_component_DxItem, {
              location: "after",
              name: "searchPanel"
            }),
            _createVNode(_component_DxItem, { location: "after" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dataSource.reload()))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 200,
          placeholder: "Caută..."
        }),
        _createVNode(_component_DxPaging, { "page-size": 20 }),
        _createVNode(_component_DxFilterRow, { visible: true })
      ]),
      _: 1
    }, 8, ["data-source"])
  ]))
}